module.exports = __webpack_public_path__ + "icomoon.d45da545bf6e712aecf6.svg";


//////////////////
// WEBPACK FOOTER
// D:/TMB/TMB/MYTMB.UI/src/assets/scss/fonts/icomoon.svg?nz9mpy
// module id = ../../../../../src/assets/scss/fonts/icomoon.svg?nz9mpy
// module chunks = styles